import * as _ from 'lodash';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';
import { isBefore, isAfter } from 'date-fns';

export const CommonUtil = {
  getArrayByValidate: (arrayValues): any[] => {
    let result = [];
    if (Array.isArray(arrayValues)) {
      if (arrayValues.length > 0) {
        result = arrayValues;
      }
    }

    return result;
  },

  nanDistinguish(num) {
    if (isNaN(num)) {
      return 0;
    } else {
      return num;
    }
  },

  debounceRequest({ params, requestMethod, url, setState }) {
    return _.debounce(async ({ params, requestMethod, url, setState }) => {
      if (requestMethod === 'GET') {
        const { status, data } = await axiosDummyInstance.get(url, params);
        if (status === 200) {
          return setState(data);
        }
      } else if (requestMethod === 'POST') {
        const { status, data } = await axiosDummyInstance.post(url, params, { withCredentials: true });
        if (status === 200) {
          setState(data);
        }
      }
    }, 1000)({ params, requestMethod, url, setState });
  },

  debounceRequestWithType({ searchText, requestMethod, url, setState, type }) {
    return _.debounce(async ({ searchText, requestMethod, url, setState, type }) => {
      if (requestMethod === 'GET') {
        const { status, data } = await axiosDummyInstance.get(url, { params: { searchText: searchText } });
        if (status === 200) {
          return setState(data);
        }
      } else if (requestMethod === 'POST') {
        const { status, data } = await axiosDummyInstance.post(
          url,
          { searchText: searchText, type },
          { withCredentials: true }
        );
        if (status === 200) {
          setState(data);
        }
      }
    }, 1000)({ searchText, requestMethod, url, setState, type });
  },

  addDate(date, days) {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  },

  objectGenerator(property, value) {
    let temp = {};
    temp[property] = property;
    temp['value'] = value;
    return temp;
  },
};

/**
 * @description Analyze Keyword > Bpart > Tracked keywords filter options
 * @param {*} filterObj (rank, group, score, chance, diff, text, date)
 * @returns
 */
export const filterObjFunction = (gridData, filterObj) => {
  let result = gridData;
  const {
    rank = null,
    group = null,
    score = null,
    chance = null,
    diff = null,
    text = null, // keyword search
    date = null,
  } = filterObj;
  // rank 는 1-100 이런값을 보냄 (전체일땐 'All')
  if (rank) {
    if (rank !== 'All') {
      const range = rank.split('-').map((item) => parseInt(item));
      result = result.filter((dataObj) => {
        let filterDecision;
        let compareAppRank = dataObj?.rank;
        if (range[0] < compareAppRank && compareAppRank < range[1]) {
          filterDecision = true;
        }
        return filterDecision;
      });
    }
  }

  // score
  if (score) {
    if (score !== 'All') {
      result = result.filter((dataObj) => {
        let filterDecision = false;
        if (dataObj?.searchscore >= parseInt(score)) {
          filterDecision = true;
        }
        return filterDecision;
      });
    }
  }

  // chance
  if (chance) {
    if (chance !== 'All') {
      result = result.filter((dataObj) => {
        let filterDecision = false;
        if (dataObj?.chance >= parseInt(chance)) {
          filterDecision = true;
        }
        return filterDecision;
      });
    }
  }
  // diff
  if (diff) {
    if (diff !== 'All') {
      result = result.filter((dataObj) => {
        let filterDecision = false;
        if (dataObj?.diff >= parseInt(diff)) {
          filterDecision = true;
        }
        return filterDecision;
      });
    }
  }
  // group
  if (group) {
    if (group !== 'All') {
      result = result.filter((dataObj) => {
        let filterDecision = false;
        if (dataObj?.group === group) {
          filterDecision = true;
        }
        return filterDecision;
      });
    }
  }
  // keywordText
  if (text) {
    result = result.filter((dataObj) => {
      let filterDecision = false;
      if (dataObj.keyword.includes(text)) {
        filterDecision = true;
      }
      return filterDecision;
    });
  }
  // date
  if (date) {
    console.log('date: ', date);
    result = result.filter((dataObj) => {
      let filterDecision = false;
      if (
        isAfter(new Date(dataObj.trackdate), new Date(date[0])) &&
        isBefore(new Date(dataObj.trackdate), new Date(date[1]))
      ) {
        filterDecision = true;
      }
      return filterDecision;
    });
  }

  return result;
};

/**
 * @description ASO Score 점수에 따른 컬러값 리턴
 * @param {*} score
 * @returns
 */
export const scoreColorDistinguish = (score) => {
  const intScore = parseInt(score);
  if (intScore >= 70) {
    return '#0bb783'; // 초록색
  } else if (intScore >= 60) {
    return '#efaa4d'; // 주황색
  } else {
    return '#f64e60'; // 빨강색
  }
};

/**
 * @description MKO Score 점수에 따른 텍스트값 리턴
 * @param {*} score
 * @param {*} text
 * @returns
 */
export const mkoScoreDescription = (score, text) => {
  const intScore = parseInt(score);
  if (intScore >= 70) {
    return `The length of the App ${text} looks great!`;
  } else if (intScore >= 60) {
    return `The length of the App ${text} looks very short!`;
  } else {
    return `Too bad, your app is missing an opportunity to share information about ${text} with users.`;
  }
};

/**
 * @description CRO에서 비디오 컴포넌트에서 영상인지 사진인지 구분하는 함수
 * @param url
 * @returns
 */
export const isVideo = (url) => {
  return url
    .toString()
    .match(
      /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/
    );
};

/**
 * @description resettaScore의
 * @param totalScore
 * @return series의 plotBands 범위, totalScore에 따른 색상
 */
export const rosettaScorePlotBandColor = (totalScore = null) => {
  let totalScoreColor;

  if (totalScore < 120) {
    totalScoreColor = '#DF5353'; // red
  } else if (120 < totalScore && totalScore < 160) {
    totalScoreColor = '#DDDF0D'; // yellow
  } else if (160 < totalScore) {
    totalScoreColor = '#55BF3B'; // green
  } else {
    totalScoreColor = null;
  }

  return {
    totalScoreColor,
    plotBands: [
      {
        from: 0,
        to: 120,
        color: '#DF5353', // red
        thickness: 20,
      },
      {
        from: 120,
        to: 160,
        color: '#DDDF0D', // yellow
        thickness: 20,
      },
      {
        from: 160,
        to: 300,
        color: '#55BF3B', // green
        thickness: 20,
      },
    ],
  };
};
